import { Text } from '@chakra-ui/react';

export const TexasHeader = ({ text }: { text: string }) => (
  <Text variant="header" textTransform="uppercase" fontSize="4xl">
    {text}
  </Text>
);
